import React from 'react';
import styled from 'styled-components';
import PropTypes from "prop-types";
import ShapeSwitch from "./ShapeSwitch";
import classNames from "classnames";

const Holder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  width: 100%;
`;

const ButtonHolder = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;

  button {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    svg {
      width: 100%;
      height: 100%;
      overflow: visible;

      path, ellipse, circle, rect, polygon {
        fill: transparent;
        stroke: var(--color-1);
        stroke-width: 1px;
        vector-effect: non-scaling-stroke;
      }
    }

    &.rotate-90 svg { transform: rotate(90deg); }

    &.rotate-180 svg { transform: rotate(180deg); }

    &.rotate-270 svg { transform: rotate(270deg); }
    
    &.active svg { path, ellipse, circle, rect, polygon { fill: var(--color-1); } }
  }
`;

const rotations = [
  0,
  90,
  270,
  180,
]

function ShapeButtons(props) {
  return (
    <Holder>
      {
        rotations.map((rotation) => {
          const buttonClasses = classNames(
            `rotate-${rotation}`,
            {'active': props.settings.rotation === rotation}
          )
          return (
            <ButtonHolder key={rotation}>
              <button className={buttonClasses} onClick={() => props.clickHandler('rotation', rotation)}>
                <ShapeSwitch shapeId={props.settings.shape} />
              </button>
            </ButtonHolder>
          )
        })
      }
    </Holder>
  )
}

ShapeButtons.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
};

export default ShapeButtons;